import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

const SaveButton = ({ title = 'Save changes', loading, disabled, onClick }) => (
  <Button kind="primary" onClick={onClick} disabled={disabled} style={{ width: '150px' }}>
    {loading ? <i className="fa fa-spin fa-spinner" /> : title}
  </Button>
);

SaveButton.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SaveButton;



// WEBPACK FOOTER //
// src/components/shared/SaveButton/index.jsx